<template>
  <b-modal
    id="edit-modal"
    no-close-on-backdrop
    ok-title="確認"
    centered
    header-bg-variant="primary"
    ok-only
    @hidden="handleHide"
  >
    <template #modal-title>
      <h4 class="m-0 model-header">
        編輯主機
      </h4>
    </template>

    <validation-observer
      #default="{ handleSubmit }"
      ref="refFormObserver"
    >
      <b-form
        @submit.prevent="handleSubmit(onSubmit)"
        @reset.prevent="resetForm"
      >
        <!-- IP位置 -->
        <validation-provider
          #default="{ errors }"
          name="IP位置"
          rules="required"
        >
          <b-form-group label-for="assigned_ip">
            <template #label>
              <label class="mb-0">
                IP位置
                <span class="text-danger">*</span>
              </label>
            </template>

            <b-form-input
              id="assigned_ip"
              v-model="deviceDataItem.assigned_ip"
              autofocus
              :state="errors.length > 0 ? false : null"
              trim
              :placeholder="deviceItem.assigned_ip ? deviceItem.assigned_ip : '192.168.1.0'"
            />

            <b-form-invalid-feedback>
              {{ errors[0] }}
            </b-form-invalid-feedback>
          </b-form-group>
        </validation-provider>

        <div>
          <label>主機說明</label>
          <b-form-textarea
            v-model="deviceDataItem.description"
            :placeholder="deviceItem.description ? deviceItem.description : '請輸入主機說明'"
            :state="deviceDataItem.description.length <= maxChar ? null : false"
            rows="5"
          />
          <small
            class="textarea-counter-value float-right"
            :class="deviceDataItem.description.length > maxChar ? 'bg-danger' : ''"
          >
            <span class="char-count">{{ deviceDataItem.description.length }}</span> / {{ maxChar }}
          </small>
        </div>
      </b-form>
    </validation-observer>

    <template #modal-footer>
      <div class="w-100 text-right">
        <b-button
          variant="primary"
          :disabled="isBusy"
          @click="handleOk"
        >
          <span v-if="!isBusy">確認</span>

          <b-spinner
            v-else
            small
          />
        </b-button>
      </div>
    </template>

  </b-modal>
</template>

<script>
// API
import { ref } from '@vue/composition-api'
import { required } from '@validations'
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'

// UI
import {
  BForm, BFormGroup, BFormInput, VBToggle, BButton, BSpinner, BFormInvalidFeedback, BFormTextarea,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

// Component
import formValidation from '@core/comp-functions/forms/form-validation'
import { useDevicePCList, useDeviceSetting } from '../useDevice'
import { useAlert } from '@/libs/mixins/index'
// import store from '@/store'

export default {
  components: {
    BForm,
    BFormGroup,
    BFormInput,
    BButton,
    BSpinner,
    BFormTextarea,
    BFormInvalidFeedback,

    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
    'b-toggle': VBToggle,
  },
  props: {
    deviceItem: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      required,
      missingFields: [],
      maxChar: 255,
    }
  },
  methods: {
    // 按下彈窗關閉
    handleHide(bvModalEvt) {
      bvModalEvt.preventDefault()
      this.resetDeviceData()
      this.isBusy = false
      this.$nextTick(() => {
        this.$bvModal.hide('edit-modal')
      })
    },

    // 按下彈窗確認
    handleOk(bvModalEvt) {
      bvModalEvt.preventDefault()

      // 判斷必填欄位是否填寫
      const requiredFields = {
        assigned_ip: 'IP位置',
      }

      this.missingFields = []

      for (let i = 0; i < Object.keys(requiredFields).length; i += 1) {
        if (this.deviceDataItem[Object.keys(requiredFields)[i]] === null || this.deviceDataItem[Object.keys(requiredFields)[i]] === '') {
          this.missingFields.push({
            lable: Object.values(requiredFields)[i],
            value: Object.keys(requiredFields)[i],
          })
        }
      }

      if (this.deviceDataItem.description.length > this.maxChar) {
        this.useAlertToast(false, '主機說明字數超過上限')
        return
      }

      if (this.missingFields.length > 0) {
        this.useAlertToast(false, `${this.missingFields[0].lable}不得為空`)
        return
      }

      this.isBusy = true

      this.setDevicePCUpdate({
        pc_id: this.deviceItem.id,
        data: {
          ...this.deviceDataItem,
        },
      })
        .then(response => {
          this.useHttpCodeAlert(response)
          this.$emit('refetch-data')
          this.resetDeviceData()
          this.$nextTick(() => {
            this.$bvModal.hide('edit-modal')
          })
          this.isBusy = false
        })
        .catch(error => {
          this.useHttpCodeAlert(error.response)
          this.isBusy = false
        })
    },

    // (獲取)資料
    getData() {
      const resolveData = {
        ...this.syncObject(this.blankDeviceData, this.deviceItem),
      }
      this.deviceDataItem = resolveData
      this.$bvModal.show('edit-modal')
    },
  },
  setup() {
    localize('tw')

    const {
      syncObject,
    } = useDeviceSetting()

    const {
      isBusy,
      setDevicePCUpdate,
    } = useDevicePCList()

    const {
      useAlertToast,
      useHttpCodeAlert,
    } = useAlert()

    const blankDeviceData = {
      assigned_ip: null,
      description: '',
    }

    const deviceDataItem = ref(JSON.parse(JSON.stringify(blankDeviceData)))

    const resetDeviceData = () => {
      deviceDataItem.value = JSON.parse(JSON.stringify(blankDeviceData))
      isBusy.value = false
    }

    const {
      refFormObserver,
      getValidationState,
      resetForm,
    } = formValidation(resetDeviceData)

    return {
      isBusy,
      syncObject,

      deviceDataItem,
      blankDeviceData,
      setDevicePCUpdate,
      useAlertToast,
      useHttpCodeAlert,

      resetDeviceData,
      refFormObserver,
      getValidationState,
      resetForm,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>

<style lang="scss" scoped>
.model-header {
  color: white;
  padding: 5px 0;
}
</style>
